import React, { useCallback } from 'react';
import {
  Box,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Collapse
} from '@mui/material';

import DebouncedTextField from '../../Utils/debounce';


export default function AccertamentoInfermieristico({ parameters, setParameters }) {

  const set = (key, value) =>
    setParameters(prev => ({ ...prev, [key]: value }));

  const setField = useCallback((key, value) => {
    setParameters(prev => ({ ...prev, [key]: value }));
  }, []);

  const toggleRadio = (key, newValue) =>
    set(key, parameters[key] === newValue ? '' : newValue);

  const p = parameters;

  return (
    <Box component="form" sx={{ width: '50ch', display: 'grid', gap: 2 }}>
      <Box
        sx={{ m: 1, width: '100%', display: 'grid', rowGap: 2, columnGap: 3 }}
        noValidate
        autoComplete="off"
      >
        {/* TITOLO */}
        <Box sx={{ p: 3, mb: 2, border: '1px solid rgba(0,0,0,0.23)', borderRadius: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
          <Box component="h1" sx={{ m: 0, fontSize: '1.8rem', fontWeight: 'bold', color: '#1976d2' }}>
            Accertamento Infermieristico
          </Box>
          <Box component="p" sx={{ m: 0, mt: 1, fontSize: '1rem', color: 'text.secondary' }}>
            Gestione della salute
          </Box>
        </Box>

        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <Box>
            {[
              ['Ipertensione', 'ipertensione'],
              ['Ipotensione', 'ipotensione'],
            ].map(([label, key]) => (
              <FormControl key={key} sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                <FormLabel sx={{ minWidth: 160 }}>{label}</FormLabel>
                <RadioGroup row value={p[key] ?? ''}>
                  <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio(key, 'true')}  />} label="Sì" />
                  <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio(key, 'false')} />} label="No" />
                </RadioGroup>
              </FormControl>
            ))}
          </Box>

          <Box>
            {[
              ['Consumo di alcol', 'alcol'],
              ['Fumo', 'fumo'],
            ].map(([label, key]) => (
              <FormControl key={key} sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                <FormLabel sx={{ minWidth: 160 }}>{label}</FormLabel>
                <RadioGroup row value={p[key] ?? ''}>
                  <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio(key, 'true')}  />} label="Sì" />
                  <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio(key, 'false')} />} label="No" />
                </RadioGroup>
              </FormControl>
            ))}
          </Box>
        </FormControl>

        {/* Diabete */}
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <FormLabel sx={{ minWidth: 160 }}>Diabete</FormLabel>
          <RadioGroup row value={p.diabete ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('diabete', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('diabete', 'false')} />} label="No" />
          </RadioGroup>
          {p.diabete === 'true' && (
            <DebouncedTextField
              size="small"
              label="Tipo di diabete"
              value={p.diabeteTipo ?? ''}
              onChange={(val) => setField('diabeteTipo', val)}
            />
          )}
        </FormControl>

        {/* Problemi cardiaci */}
        <FormControl
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'nowrap',
          }}
        >
          <FormLabel sx={{ minWidth: 160, flexShrink: 0 }}>
            Problemi cardiaci
          </FormLabel>

          <RadioGroup row value={p.probCardiaci ?? ''} sx={{ flexShrink: 0 }}>
            <FormControlLabel
              value="true"
              control={
                <Radio
                  onClick={() => toggleRadio('probCardiaci', 'true')}
                />
              }
              label="Sì"
            />

            <FormControlLabel
              value="false"
              control={
                <Radio
                  onClick={() => toggleRadio('probCardiaci', 'false')}
                />
              }
              label="No"
            />
          </RadioGroup>

          <Collapse
            in={p.probCardiaci === 'true'}
            orientation="horizontal"
            sx={{ flexShrink: 0 }}
          >
            <Box sx={{ display: 'flex', gap: 2 }}>
              <DebouncedTextField
                size="small"
                label="Tipo di problema cardiaco"
                value={p.probCardiaciTipo ?? ''}
                onChange={(val) => setField('probCardiaciTipo', val)}
              />

              <DebouncedTextField
                size="small"
                label="Apparecchio utilizzato"
                value={p.probCardiaciApparecchio ?? ''}
                onChange={(val) => setField('probCardiaciApparecchio', val)}
              />
            </Box>
          </Collapse>
        </FormControl>


        {/* Problemi respiratori */}
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <FormLabel sx={{ minWidth: 160 }}>Problemi respiratori</FormLabel>
          <RadioGroup row value={p.probRespiratori ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('probRespiratori', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('probRespiratori', 'false')} />} label="No" />
          </RadioGroup>
          <Collapse in={p.probRespiratori === 'true'}>
            <>
              <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                <FormLabel sx={{ minWidth: 160 }}>O₂ Terapia</FormLabel>
                <RadioGroup row value={p.o2Terapia ?? ''}>
                  <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('o2Terapia', 'true')}  />} label="Sì" />
                  <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('o2Terapia', 'false')} />} label="No" />
                </RadioGroup>
              </FormControl>
              <Collapse in={p.o2Terapia === 'true'}>
                <DebouncedTextField size="small" label="Tipo di O₂ terapia"
                  value={p.o2TerapiaTipo ?? ''}
                  onChange={(val) => setField('o2TerapiaTipo', val)} />
              </Collapse>
            </>
          </Collapse>
        </FormControl>

        {/* Uso di sostanze */}
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <FormLabel sx={{ minWidth: 160 }}>Uso di sostanze</FormLabel>
          <RadioGroup row value={p.sostanze ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('sostanze', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('sostanze', 'false')} />} label="No" />
          </RadioGroup>
          {p.sostanze === 'true' && (
            <DebouncedTextField size="small" label="Tipo di sostanza"
              value={p.sostanzeTipo ?? ''}
              onChange={(val) => setField('sostanzeTipo', val)} />
          )}
        </FormControl>

        {/* Attività fisica */}
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <FormLabel sx={{ minWidth: 160 }}>Attività fisica</FormLabel>
          <RadioGroup row value={p.attivitaFisica ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('attivitaFisica', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('attivitaFisica', 'false')} />} label="No" />
          </RadioGroup>
        </FormControl>

        {/* Deambulazione */}
        <div style={{"display":"flex"}}>
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <FormLabel sx={{ minWidth: 160 }}>Deambula</FormLabel>
          <RadioGroup row value={p.deambula ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('deambula', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('deambula', 'false')} />} label="No" />
          </RadioGroup>
        </FormControl>
        <Collapse in={p.deambula === 'false'}>
          <FormControl sx={{ ml: 10, flexDirection: 'row', alignItems: 'center', gap: 2 }}>
            <RadioGroup value={p.ausilio ?? ''} onChange={e => set('ausilio', e.target.value)}>
              {['Stampelle', 'Deambulatore', 'Bastone', 'Split/Tutore', 'Sedia a rotelle', 'Altro'].map(a => (
                <FormControlLabel key={a} value={a} control={<Radio />} label={a} />
              ))}
            </RadioGroup>
          </FormControl>
        </Collapse>
        </div>


        
        {/* Mobilità a letto */}
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <FormLabel sx={{ minWidth: 160 }}>Mobilità a letto</FormLabel>
          <RadioGroup row value={p.mobilitaLetto ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('mobilitaLetto', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('mobilitaLetto', 'false')} />} label="No" />
          </RadioGroup>
        </FormControl>

        {/* Allergie */}
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <FormLabel sx={{ minWidth: 160 }}>Allergie</FormLabel>
          <RadioGroup row value={p.allergie ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('allergie', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('allergie', 'false')} />} label="No" />
          </RadioGroup>
          <Collapse in={p.allergie === 'true'}>
            <FormControl sx={{ flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <DebouncedTextField size="small" label="Farmaci"
                value={p.allergieFarmaci ?? ''}
                onChange={(val) => setField('allergieFarmaci', val)} />
              <DebouncedTextField size="small" label="Alimenti"
                value={p.allergieAlimenti ?? ''}
                onChange={(val) => setField('allergieAlimenti', val)} />
              <DebouncedTextField size="small" label="Altre sostanze"
                value={p.allergieSostanze ?? ''}
                onChange={(val) => setField('allergieSostanze', val)} />
            </FormControl>
          </Collapse>
        </FormControl>

        {/* Terapia */}
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <FormLabel sx={{ minWidth: 160 }}>Terapia</FormLabel>
          <RadioGroup row value={p.terapia ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('terapia', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('terapia', 'false')} />} label="No" />
          </RadioGroup>
          <Collapse in={p.terapia === 'true'}>
            <DebouncedTextField size="small" label="Specificare terapia"
              value={p.terapiaDescrizione ?? ''}
              onChange={(val) => setField('terapiaDescrizione', val)} />
          </Collapse>
        </FormControl>

      </Box>
    </Box>
  );
}